export const INIT_PUSHER = 'INIT_PUSHER'
export const INIT_PUSHER_FULFILLED = 'INIT_PUSHER_FULFILLED'
export const INIT_PUSHER_REJECTED = 'INIT_PUSHER_REJECTED'

/**
 * @typedef {object} InitPayload
 * @property {string} appKey - Pusher app key
 * @property {string} appCluser - Pusher app cluster
 * @property {object} Pusher - Pusher instance
 */
/**
 * Initialize the pusher socket
 * @param {InitPayload} payload
 */
export const initPusher = (payload) => ({ type: INIT_PUSHER, payload })

export const SUBSCRIBE_TO_CHANNEL = 'SUBSCRIBE_TO_CHANNEL'
export const SUBSCRIBE_TO_CHANNEL_FULFILLED = 'SUBSCRIBE_TO_CHANNEL_FULFILLED'
export const SUBSCRIBE_TO_CHANNEL_REJECTED = 'SUBSCRIBE_TO_CHANNEL_REJECTED'

/**
 * Subscribe to a channel
 * @param {{channelId: {string}}} payload - channelId is the id of the channel to subscribe to
 */
export const subscribeToChannel = (payload) => ({
  type: SUBSCRIBE_TO_CHANNEL,
  payload,
})

export const UNSUBSCRIBE_FROM_CHANNEL = 'UNSUBSCRIBE_FROM_CHANNEL'
export const UNSUBSCRIBE_FROM_CHANNEL_FULFILLED =
  'UNSUBSCRIBE_FROM_CHANNEL_FULFILLED'
export const UNSUBSCRIBE_FROM_CHANNEL_REJECTED =
  'UNSUBSCRIBE_FROM_CHANNEL_REJECTED'

/**
 * Unsubscribe from a channel
 * @param {{channelId: {string}}} payload - channelId is the id of the channel to unsubscribe from
 */
export const unsubscribeFromChannel = (payload) => ({
  type: UNSUBSCRIBE_FROM_CHANNEL,
  payload,
})

export const BIND_TO_CHANNEL_EVENT = 'BIND_TO_CHANNEL_EVENT'
export const BIND_TO_CHANNEL_EVENT_FULFILLED = 'BIND_TO_CHANNEL_EVENT_FULFILLED'
export const BIND_TO_CHANNEL_EVENT_REJECTED = 'BIND_TO_CHANNEL_EVENT_REJECTED'

/**
 * Bind to an event through a channel
 * @param {{channelId: {string} eventId: {string} }} payload - channelId is the id of the channel to subscribe to, eventId is the binding event to watch
 */
export const bindToChannelEvent = (payload) => ({
  type: BIND_TO_CHANNEL_EVENT,
  payload,
})

export const UNBIND_FROM_CHANNEL_EVENT = 'UNBIND_FROM_CHANNEL_EVENT'
export const UNBIND_FROM_CHANNEL_EVENT_FULFILLED =
  'UNBIND_FROM_CHANNEL_EVENT_FULFILLED'
export const UNBIND_FROM_CHANNEL_EVENT_REJECTED =
  'UNBIND_FROM_CHANNEL_EVENT_REJECTED'

/**
 * Unbind from an event through a channel
 * @param {{channelId: {string} eventId: {string} }} payload - channelId is the id of the channel to unsubscribe from, eventId is the binding event to remove
 */
export const unbindFromChannelEvent = (payload) => ({
  type: UNBIND_FROM_CHANNEL_EVENT,
  payload,
})

export const STAY_SUBSCRIBED_TO_PUSHER_CHANNEL =
  'STAY_SUBSCRIBED_TO_PUSHER_CHANNEL'

/**
 * This is a NO_OP to indicate that we received a Pusher event
 * for a channel and have decided to stay subscribed for future events.
 */
export const staySubscribedToPusherChannel = () => ({
  type: STAY_SUBSCRIBED_TO_PUSHER_CHANNEL,
})
